// assets
import {
  IconAsset,
  IconCurrencyTaka,
  IconReceiptDollarFilled,
  IconListDetails,
  IconWashMachine,
  IconBooks,
  IconSquarePlus,
  IconGasStation,
  IconChartHistogram,
} from '@tabler/icons-react';

// constant
const icons = {
  IconAsset,
  IconCurrencyTaka,
  IconReceiptDollarFilled,
  IconListDetails,
  IconWashMachine,
  IconBooks,
  IconSquarePlus,
  IconGasStation,
  IconChartHistogram,
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const vehicle = {
  id: 'vehicle',
  title: 'Vehicle Management',
  type: 'group',
  access: ['super_admin', 'admin'],
  children: [
    {
      id: 'operation-expenses',
      title: 'Operation Expenses',
      type: 'collapse',
      color: '#0C356A',
      icon: icons.IconListDetails,
      access: ['super_admin', 'admin'],
      children: [
        {
          id: 'fuel-expenses',
          title: 'Fuel Expenses',
          type: 'item',
          url: '/vehicle/operation-expenses/fuel-expenses',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'driver-salaries',
          title: 'Driver Salaries',
          type: 'item',
          url: '/vehicle/operation-expenses/driver-salaries',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'other-expenses',
          title: 'Other Expenses',
          type: 'item',
          url: '/vehicle/operation-expenses/other-expenses',
          access: ['super_admin', 'admin'],
        },
      ],
    },
    {
      id: 'maintenance-expenses',
      title: 'Maintenance Expenses',
      type: 'collapse',
      color: '#0C356A',
      icon: icons.IconAsset,
      access: ['super_admin', 'admin'],
      children: [
        {
          id: 'routine-services',
          title: 'Routine Services',
          type: 'item',
          url: '/vehicle/maintenance-expenses/routine-services',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'master-services',
          title: 'Master Services',
          type: 'item',
          url: '/vehicle/maintenance-expenses/master-services',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'other-maintenances',
          title: 'Other Maintenances',
          type: 'item',
          url: '/vehicle/maintenance-expenses/other-maintenances',
          access: ['super_admin', 'admin'],
        },
      ],
    },
    {
      id: 'vehicle-library',
      title: 'Library',
      type: 'collapse',
      color: '#0C356A',
      icon: icons.IconBooks,
      access: ['super_admin', 'admin'],
      children: [
        {
          id: 'vehicle-list',
          title: 'Vehicle List',
          type: 'item',
          url: '/vehicle/vehicle-library/vehicle-list',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'driver-list',
          title: 'Driver List',
          type: 'item',
          url: '/vehicle/vehicle-library/driver-list',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'vehicle-expense-category',
          title: 'Expense Category',
          type: 'item',
          url: '/vehicle/vehicle-library/vehicle-expense-category',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'vehicle-expense-head',
          title: 'Expense Heads',
          type: 'item',
          url: '/vehicle/vehicle-library/vehicle-expense-head',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'service-provider',
          title: 'Service Provider',
          type: 'item',
          url: '/vehicle/vehicle-library/service-provider',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'fuel-pump',
          title: 'Fuel Pumps',
          type: 'item',
          url: '/vehicle/vehicle-library/fuel-pump',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'fuel-price',
          title: 'Fuel Price',
          type: 'item',
          url: '/vehicle/vehicle-library/fuel-price',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'service-items',
          title: 'Service Items',
          type: 'item',
          url: '/vehicle/vehicle-library/service-items',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'payment-sources',
          title: 'Payment Sources',
          type: 'item',
          url: '/vehicle/vehicle-library/payment-sources',
          access: ['super_admin', 'admin'],
        },
      ],
    },
    {
      id: 'vehicle-report',
      title: 'Report',
      type: 'collapse',
      color: '#0C356A',
      icon: icons.IconChartHistogram,
      access: ['super_admin', 'admin'],
      children: [
        {
          id: 'summary',
          title: 'Summary',
          type: 'item',
          url: '/vehicle/vehicle-report/summary',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'expense-head-summary',
          title: 'Expense Head Summary',
          type: 'item',
          url: '/vehicle/vehicle-report/expense-head-summary',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'fuel-analysis',
          title: 'Fuel Analysis',
          type: 'item',
          url: '/vehicle/vehicle-report/fuel-analysis',
          access: ['super_admin', 'admin'],
        },
        {
          id: 'maintenance-summary',
          title: 'Maintenance Summary',
          type: 'item',
          url: '/vehicle/vehicle-report/maintenance-summary',
          access: ['super_admin', 'admin'],
        },
      ],
    },
  ],
};

export default vehicle;
